import { FC } from 'react';
import StudentBulkInsert from './StudentBulkInsert';
import UseStudentBulkInsert from './UseStudentBulkInsert';

const StudentBulkInsertContainer: FC = () => {
  return <StudentBulkInsert {...UseStudentBulkInsert()} />;
};

export default StudentBulkInsertContainer;
